import { createI18n } from 'vue-i18n'
import { ru } from './ru'
import { kz } from './kz'
import { en } from './en'

const dataMessages = {
  ru,
  en,
  kz
}

export const i18n = createI18n({
  locale: localStorage.getItem('lang') || 'ru',
  fallbackLocale: 'ru',
  messages: dataMessages
})
